module.exports = __webpack_public_path__ + "img/pricingDownloadCover.96034dd7.png";